"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

export function RoleTab() {
  const pathname = usePathname();
  const segment = pathname.split("/").at(-1);
  const href = pathname.substring(0, pathname.lastIndexOf("/"));

  return (
    <div role="tablist" className="tabs tabs-border w-full">
      <Link href={href + "/bat"} role="tab" className={`w-1/2 tab ${segment === "bat" && "tab-active"}`}>
        打撃成績
      </Link>
      <Link href={href + "/pit"} role="tab" className={`w-1/2 tab ${segment === "pit" && "tab-active"}`}>
        投手成績
      </Link>
    </div>
  );
}
